module.exports = __webpack_public_path__ + "static/media/component-4.f485dcf2.svg";